<template>
    <vue-content-loading :height="200">
        <rect x="25" y="15" rx="5" ry="5" width="260" height="24.2" />
        <rect x="25" y="55" rx="5" ry="5" width="220" height="10" />
        <rect x="25" y="70" rx="5" ry="5" width="210" height="10" />
        <rect x="25" y="85" rx="5" ry="5" width="220" height="10" />
        <rect x="25" y="100" rx="5" ry="5" width="210" height="10" />
        <rect x="25" y="115" rx="5" ry="5" width="220" height="10" />
        <rect x="25" y="130" rx="5" ry="5" width="210" height="10" />
        <rect x="25" y="145" rx="5" ry="5" width="220" height="10" />
        <rect x="25" y="160" rx="5" ry="5" width="210" height="10" />
        <rect x="25" y="175" rx="5" ry="5" width="220" height="10" />
        <rect x="25" y="190" rx="5" ry="5" width="210" height="10" />
    </vue-content-loading>
</template>

<script>
    import VueContentLoading from 'vue-content-loading';
    export default {
        name: "spinner-paso2",
        components: {
            VueContentLoading,
        },
    }
</script>

<style scoped>

</style>